<template>
    <div>
        <v-autocomplete
                v-model="center"
                :label="label"
                :items="medicalCenterStore.medicalCenters"
                item-value="id"
                item-text="name"
                outlined
                :color="inputColor"
                :background-color="backgroundColor"
                dense
                :readonly="readonly"
                :clearable="!readonly"
                :multiple="multiple"
                hide-details="auto"
                @input="$emit('input', center)"
                :rules="rules"
        ></v-autocomplete>

        <input type="hidden"/>
    </div>
</template>


<script>
import useSharedData from "@/use/SharedData";
import {onMounted, ref, watch} from "vue";
import {useMedicalCenterStore} from "@/stores/Medical/MedicalCenter";
import axios from "axios";

export default {
    name: "StrMedicalCenterAutocomplete",
    props: {
        value: [Number, Array],
        readonly: Boolean,
        label: String,
        multiple: Boolean,
        rules: Array,
    },
    setup(props) {
        const {loading, inputColor, backgroundColor} = useSharedData();
        const medicalCenterStore = useMedicalCenterStore();
        const center = ref(null);

        function findAll() {
          loading.value = true;
          axios.get(`/medicalCenters`).then(response => {
             medicalCenterStore.setMedicalCenters(response.data);
          }).finally(() => {
              loading.value = false;
          });
        }

        watch(() => props.value, () => {
            center.value = props.value;
        }, {immediate: true});

        onMounted(() => findAll());

        return {
            medicalCenterStore,
            loading,
            center,
            inputColor,
            backgroundColor
        }
    }
};
</script>